import { useState } from 'react';

export default function NewsletterCTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('phone_alt') as string || '').trim();
    if (honeypotValue) {
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
      return;
    }

    const userEmail = (formData.get('email') as string || '').trim();
    if (!userEmail) {
      setStatus('error');
      setErrorMsg('请输入有效的邮箱地址');
      return;
    }

    setStatus('submitting');

    try {
      const payload = new URLSearchParams();
      payload.append('email', userEmail);
      payload.append('formId', 'd9qm7kvnahb7382ovc3g');

      const response = await fetch('https://readdy.ai/api/form/d9qm7kvnahb7382ovc3g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试';
        setStatus('error');
        setErrorMsg(msg);
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20dark%20gradient%20abstract%20background%20with%20soft%20golden%20light%20streaks%20and%20gentle%20sparkle%20effects%2C%20mysterious%20romantic%20atmosphere%2C%20warm%20amber%20highlights%20on%20deep%20charcoal%2C%20no%20text%2C%20cinematic%20quality&width=1600&height=600&seq=cta-bg-2026&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-black/60"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
          订阅更新通知
        </h2>
        <p className="text-sm md:text-base text-background-50/70 mb-8">
          第一时间获取最新小说更新、限时福利和独家推荐，不错过任何精彩内容
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form="true"
          className="flex flex-col sm:flex-row items-center gap-3 max-w-lg mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入您的邮箱地址"
            required
            className="flex-1 w-full px-5 py-3 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 placeholder-background-50/40 text-sm outline-none focus:border-primary-400 focus:bg-background-50/20 transition-all duration-200"
          />
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <button
            type="submit"
            disabled={status === 'submitting'}
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 font-semibold rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            {status === 'submitting' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-accent-300 font-medium">订阅成功！感谢您的关注～</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-accent-300">{errorMsg}</p>
        )}

        <p className="mt-5 text-xs text-background-50/40">
          我们尊重您的隐私，绝不会向第三方泄露您的邮箱
        </p>
      </div>
    </section>
  );
}